<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						<v-btn
							icon
							@click="
								$inertia.visit(
									$route('tenant.reservation_shifts.index', {
										tenant: $page.props.tenant.id,
										outlet: outlet.uuid,
									})
								)
							"
						>
							<v-icon>mdi-arrow-left</v-icon>
						</v-btn>
						{{ $t("title.create_reservation_shift") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<ValidationProvider
									name="outlet_id"
									rules="required"
									v-slot="{ errors, valid }"
								>
									<v-select
										:items="outlets"
										item-value="id"
										item-text="name"
										v-model="item.outlet_id"
										:label="$t('label.outlet')"
										data-vv-name="outlet_id"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-select>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12>
								<v-btn-toggle
									mandatory
									v-model="item.day"
									class="mb-3"
								>
									<v-btn value="mon">
										{{ $t("label.monday") }}
									</v-btn>
									<v-btn value="tue">
										{{ $t("label.tuesday") }}
									</v-btn>
									<v-btn value="wed">
										{{ $t("label.wednesday") }}
									</v-btn>
									<v-btn value="thu">
										{{ $t("label.thursday") }}
									</v-btn>
									<v-btn value="fri">
										{{ $t("label.friday") }}
									</v-btn>
									<v-btn value="sat">
										{{ $t("label.saturday") }}
									</v-btn>
									<v-btn value="sun">
										{{ $t("label.sunday") }}
									</v-btn>
								</v-btn-toggle>
							</v-flex>
							<v-flex xs12>
								<ValidationProvider
									name="name"
									rules="required"
									v-slot="{ errors, valid }"
								>
									<v-text-field
										v-model="item.name"
										:label="$t('Name')"
										data-vv-name="name"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12 md4>
								<ValidationProvider
									name="time_start"
									rules="required"
									v-slot="{ errors, valid }"
								>
									<v-text-field
										type="time"
										v-model="item.time_start"
										:label="$t('label.time_start')"
										data-vv-name="time_start"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12 md4>
								<ValidationProvider
									name="time_end"
									rules="required"
									v-slot="{ errors, valid }"
								>
									<v-text-field
										type="time"
										v-model="item.time_end"
										:label="$t('label.time_end')"
										data-vv-name="time_end"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12 md4>
								<ValidationProvider
									name="time_interval"
									rules="required"
									v-slot="{ errors, valid }"
								>
									<v-select
										type="time"
										v-model="item.time_interval"
										:items="[5, 10, 15, 20, 30]"
										:label="$t('label.time_interval')"
										data-vv-name="time_interval"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-select>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12 md4>
								<ValidationProvider
									name="pax_min"
									rules="required"
									v-slot="{ errors, valid }"
								>
									<v-text-field
										type="number"
										v-model="item.pax_min"
										:label="$t('label.pax_min')"
										data-vv-name="pax_min"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12 md4>
								<ValidationProvider
									name="pax_max"
									rules="required"
									v-slot="{ errors, valid }"
								>
									<v-text-field
										type="number"
										v-model="item.pax_max"
										:label="$t('label.pax_max')"
										data-vv-name="pax_max"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12 md4>
								<ValidationProvider
									name="pax_total"
									rules="required"
									v-slot="{ errors, valid }"
								>
									<v-text-field
										type="number"
										v-model="item.pax_total"
										:label="$t('label.pax_total')"
										data-vv-name="pax_total"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12>
								<ValidationProvider
									name="description"
									rules=""
									v-slot="{ errors, valid }"
								>
									<v-textarea
										v-model="item.description"
										:label="$t('Description')"
										data-vv-name="description"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-textarea>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12>
								<ValidationProvider
									name="active"
									rules=""
									v-slot="{ errors }"
								>
									<v-switch
										v-model="item.active"
										:label="$t('Active')"
										data-vv-name="active"
										:error-messages="errors"
									></v-switch>
								</ValidationProvider>
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>
<script>
export default {
	props: ["outlets", "outlet"],
	data() {
		return {
			item: this.$inertia.form({
				outlet_id: null,
				day: null,
				name: null,
				time_start: null,
				time_end: null,
				time_interval: null,
				pax_min: null,
				pax_max: null,
				pax_total: null,
				description: null,
				active: true,
			}),
		};
	},
	methods: {
		submit() {
			this.item.post(
				this.$route("tenant.reservation_shifts.store", {
					tenant: this.$page.props.tenant.id,
					outlet: this.outlet?.uuid,
				})
			);
		},
	},
};
</script>
